/* MAIYKO EKLENTI — Beden Rehberi (yandan kayan panel)
   Bağımsız IIFE, jQuery yok, Safari 15+ uyumlu.
   Bu dosya SADECE 'maiyko-beden-rehberi' snippet'i render olduğunda yüklenir.

   TEKİL PANEL (PORTAL)
   ---------------------------------------------------------------------------
   Snippet aynı sayfada birden çok kez render edilebilir (ürün formu, yapışkan
   satın alma çubuğu, hızlı görüntüleme...). Her render kendi panel kopyasını
   basar. Burada bunlardan YALNIZCA biri seçilir, <body>'ye taşınır, geri
   kalanlar DOM'dan silinir. İki gerekçe:

   1) Konum: panel ve karartma position:fixed'tir. fixed, ataların hiçbirinde
      transform/filter/perspective yoksa ekrana göre çözülür; böyle bir ata
      varsa o ata "içeren blok" olur. Bu temanın ürün kolonlarında transform
      var — panel yerinde kalırsa ekranın kenarına değil kolonun yanına
      oturur, karartma tüm ekranı kaplamaz, kapat düğmesi ekran dışına
      düşebilir. Kısıt CSS'ten okunamaz, düğümü zincirin dışına almak tek
      güvenli çözüm (aynı desen video vitrin ve mini kuponda da kullanıldı).
   2) Kimlik: birden çok kopya aynı id'yi taşıyamaz. Bu yüzden id Liquid'de
      DEĞİL, tekil kalan düğüme burada atanır; aria-controls da açılışta
      düğmeye buradan yazılır.

   Tüm dinleyiciler document üzerinde DELEGASYONLUdur ve bir kez bağlanır:
   panel değişse (tema editörü) veya yeni düğmeler gelse de yeniden bağlama
   gerekmez.

   SEKME DURUMU
   ---------------------------------------------------------------------------
   Görsel durum ile erişilebilirlik durumu tek kaynaktan sürülür:
   sekme düğmesinde aria-selected, içerikte [hidden]. CSS de aria-selected'e
   bakar; ayrı bir "aktif" sınıfı yoktur, dolayısıyla ikisi ayrışamaz.
   Her açma düğmesi kendi başlangıç sekmesini data-maiyko-br-ilk-sekme ile
   taşır (ürün başlığına göre Liquid'de hesaplanır), böylece TEK panel farklı
   ürünlerde doğru sekmeyle açılır. */

(function () {
  'use strict';

  /* Snippet birden çok kez render edilirse <script src> etiketi de birden
     çok basılır ve tarayıcı dosyayı HER etiket için ÇALIŞTIRIR (indirmeyi
     önbellekten yapsa bile). İkinci çalıştırma ikinci bir dinleyici kümesi
     kurardı: tek tıklama iki kez açma, ESC'te durumun yarısının açık
     kalması. Global bayrak ilk örneği kazandırır. */
  if (window.maiykoBedenRehberiKuruldu) return;
  window.maiykoBedenRehberiKuruldu = true;

  var PANEL_SEC = '[data-maiyko-br-panel]';
  var AC_SEC = '[data-maiyko-br-ac]';
  var KAPAT_SEC = '[data-maiyko-br-kapat]';
  var KARARTMA_SEC = '[data-maiyko-br-karartma]';
  var SEKME_SEC = '[data-maiyko-br-sekme]';
  var KUTU_SEC = '[data-maiyko-br-kutu]';
  var PANEL_ID = 'maiyko-br-panel';
  var KILIT_SINIF = 'maiyko-br-kilit';

  var ODAKLANABILIR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  /* Sayfadaki TEK panel ve onu açan düğme. */
  var panel = null;
  var acanButon = null;
  var acik = false;
  var baglandi = false;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function closest(el, sec) {
    if (!el) return null;
    if (el.closest) return el.closest(sec);
    /* Çok eski tarayıcı yedeği. */
    var n = el;
    while (n && n.nodeType === 1) {
      if (n.matches && n.matches(sec)) return n;
      n = n.parentNode;
    }
    return null;
  }

  /* ------------------------------------------------------------------
     Kurulum: panelleri tekle, <body>'ye taşı.
     yeniKok verilirse (tema editöründe yeniden yüklenen section) onun
     içindeki panel tercih edilir — ayarları değişmiş taze kopya odur.
     ------------------------------------------------------------------ */
  function kurulum(yeniKok) {
    if (!document.body) return;

    var adaylar = toArray(document.querySelectorAll(PANEL_SEC));
    if (!adaylar.length) return;

    var secilen = null;
    if (yeniKok && yeniKok.querySelector) {
      secilen = yeniKok.querySelector(PANEL_SEC);
      if (!secilen && yeniKok.matches && yeniKok.matches(PANEL_SEC)) {
        secilen = yeniKok;
      }
    }
    if (!secilen && panel && document.body.contains(panel)) {
      secilen = panel;
    }
    if (!secilen) secilen = adaylar[0];

    /* Taze bir panel geldiyse eskisini kapat: açık kalırsa kilit ve odak
       artık DOM'da olmayan bir düğümde asılı kalırdı. */
    if (panel && panel !== secilen && acik) kapat(true);

    adaylar.forEach(function (p) {
      if (p !== secilen && p.parentNode) {
        try {
          p.parentNode.removeChild(p);
        } catch (e) {
          /* yoksay */
        }
      }
    });
    if (panel && panel !== secilen && panel.parentNode) {
      try {
        panel.parentNode.removeChild(panel);
      } catch (e2) {
        /* yoksay */
      }
    }

    if (secilen.parentNode !== document.body) {
      try {
        document.body.appendChild(secilen);
      } catch (e3) {
        /* Taşınamadıysa yerinde kalsın: konumu bozuk olabilir ama panel
           tümden çalışmaz duruma düşmez. */
      }
    }

    panel = secilen;
    panel.setAttribute('id', PANEL_ID);
    panel.setAttribute('data-maiyko-br-acik', '0');
    acik = false;

    baglaBirKez();
  }

  /* ------------------------------------------------------------------ */

  function sekmeleri(p) {
    return toArray(p.querySelectorAll(SEKME_SEC));
  }

  function sekmeSec(tur) {
    if (!panel || !tur) return;

    var sekmeler = sekmeleri(panel);
    var icerikler = toArray(panel.querySelectorAll('[data-maiyko-br-icerik]'));

    /* İstenen sekme yoksa (o tablonun verisi boş) ilk sekmeye düş. */
    var varMi = icerikler.some(function (ic) {
      return ic.getAttribute('data-maiyko-br-icerik') === tur;
    });
    if (!varMi) {
      if (!icerikler.length) return;
      tur = icerikler[0].getAttribute('data-maiyko-br-icerik');
    }

    sekmeler.forEach(function (s) {
      var secili = s.getAttribute('data-maiyko-br-sekme') === tur;
      s.setAttribute('aria-selected', secili ? 'true' : 'false');
      s.setAttribute('tabindex', secili ? '0' : '-1');
    });

    var aktifIcerik = null;
    icerikler.forEach(function (ic) {
      var bu = ic.getAttribute('data-maiyko-br-icerik') === tur;
      ic.hidden = !bu;
      if (bu) aktifIcerik = ic;
    });

    panel.setAttribute('data-maiyko-br-aktif', tur);

    /* Panel başlığı aktif içeriğe göre değişir (Beden Rehberi / TOG Rehberi). */
    var baslikEl = panel.querySelector('[data-maiyko-br-baslik]');
    if (baslikEl && aktifIcerik) {
      var yeniBaslik = aktifIcerik.getAttribute('data-maiyko-br-panel-baslik');
      if (yeniBaslik) baslikEl.textContent = yeniBaslik;
    }

    /* Beden notu TOG görünümünde anlamsız — gizle. */
    var notEl = panel.querySelector('[data-maiyko-br-not]');
    if (notEl) notEl.hidden = tur === 'tog';

    if (tur === 'tog' && aktifIcerik) togIcerikYukle(aktifIcerik);
  }

  /* TOG Rehberi içeriği TEMBEL yüklenir (sekme ilk seçildiğinde).
     Mağaza X-Frame-Options: DENY gönderdiği için iframe KULLANILAMAZ;
     bunun yerine sayfa fetch edilir, TOG bölümünün shopify-section
     sarmalayıcısı (CSS linkleri + bant JSON'u dahil) kaba enjekte edilir.
     innerHTML ile gelen <script src> ÇALIŞMAZ: maiyko-tog.js elle bir kez
     yüklenir; kurulum, dosyanın zaten dinlediği shopify:section:load
     olayı kapta kabarcıklandırılarak tetiklenir (tog.js'e dokunulmadı). */
  var togYukleDurum = 0; /* 0: hiç, 1: yükleniyor, 2: tamam */
  function togIcerikYukle(icerik) {
    if (togYukleDurum) return;
    var kap = icerik.querySelector('[data-maiyko-br-tog]');
    if (!kap) return;
    togYukleDurum = 1;
    var url = kap.getAttribute('data-url') || '/pages/tog-rehberi';

    function hata() {
      togYukleDurum = 0; /* sekmeye tekrar girilince yeniden denenir */
      kap.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'maiyko-br__tog-durum';
      p.textContent = 'Rehber şu an yüklenemedi. ';
      var a = document.createElement('a');
      a.href = url;
      a.textContent = 'Sayfada açmak için dokunun';
      p.appendChild(a);
      kap.appendChild(p);
    }

    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (y) {
        if (!y.ok) throw new Error('HTTP ' + y.status);
        return y.text();
      })
      .then(function (html) {
        var belge = new DOMParser().parseFromString(html, 'text/html');
        var bolum = belge.querySelector('[data-maiyko-tog]');
        if (!bolum) throw new Error('bolum yok');
        /* shopify-section sarmalayıcısı stylesheet_tag linklerini de taşır. */
        var sarmal = bolum.closest('[id^="shopify-section-"]') || bolum;
        kap.innerHTML = '';
        kap.appendChild(document.importNode(sarmal, true));

        /* Davranış dosyası: parçadaki <script src> etkisizdir, elle yükle. */
        var eskiScript = kap.querySelector('script[src]');
        var kur = function () {
          try {
            kap.dispatchEvent(
              new Event('shopify:section:load', { bubbles: true })
            );
          } catch (e) {
            /* yoksay */
          }
          togYukleDurum = 2;
        };
        if (window.maiykoBrTogScript) {
          kur();
        } else if (eskiScript) {
          window.maiykoBrTogScript = true;
          var sc = document.createElement('script');
          sc.src = eskiScript.getAttribute('src');
          sc.onload = kur;
          sc.onerror = hata;
          document.body.appendChild(sc);
          eskiScript.parentNode.removeChild(eskiScript);
        } else {
          kur();
        }
      })
      .catch(hata);
  }

  function kilitle() {
    if (document.documentElement) {
      document.documentElement.classList.add(KILIT_SINIF);
    }
  }

  function kilidiAc() {
    if (document.documentElement) {
      document.documentElement.classList.remove(KILIT_SINIF);
    }
  }

  function ac(btn) {
    if (!panel) kurulum(null);
    if (!panel) return;

    acanButon = btn || null;

    if (acanButon) {
      acanButon.setAttribute('aria-expanded', 'true');
      acanButon.setAttribute('aria-controls', PANEL_ID);
      var ilk = acanButon.getAttribute('data-maiyko-br-ilk-sekme');
      if (ilk) sekmeSec(ilk);
    }

    panel.setAttribute('data-maiyko-br-acik', '1');
    acik = true;
    kilitle();

    var kutu = panel.querySelector(KUTU_SEC);
    if (kutu && typeof kutu.focus === 'function') {
      /* Odak, kayma animasyonu başlamadan verilirse Safari panelin son
         konumuna kaydırma yapabilir; bir kare beklemek yeterli. */
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          try {
            kutu.focus({ preventScroll: true });
          } catch (e) {
            kutu.focus();
          }
        });
      } else {
        kutu.focus();
      }
    }
  }

  function kapat(odakVerme) {
    if (panel) panel.setAttribute('data-maiyko-br-acik', '0');
    acik = false;
    kilidiAc();

    if (acanButon) {
      acanButon.setAttribute('aria-expanded', 'false');
      if (!odakVerme && document.body && document.body.contains(acanButon)) {
        try {
          acanButon.focus({ preventScroll: true });
        } catch (e) {
          acanButon.focus();
        }
      }
    }
    acanButon = null;
  }

  /* Panel içinde Tab döngüsü: aria-modal tek başına odağı hapsetmez. */
  function odakTuzagi(e) {
    if (!panel) return;
    var kutu = panel.querySelector(KUTU_SEC);
    if (!kutu) return;

    /* Görünürlük ölçüsü olarak getClientRects kullanılır: offsetParent,
       position:fixed/sticky atalarda null dönebildiği için panel içindeki
       düğmeleri yanlışlıkla "gizli" sayardı. */
    var hedefler = toArray(kutu.querySelectorAll(ODAKLANABILIR)).filter(function (el) {
      return !el.hasAttribute('hidden') && el.getClientRects().length > 0;
    });
    if (!hedefler.length) {
      e.preventDefault();
      kutu.focus();
      return;
    }

    var ilk = hedefler[0];
    var son = hedefler[hedefler.length - 1];
    var etkin = document.activeElement;

    if (e.shiftKey) {
      if (etkin === ilk || etkin === kutu || !kutu.contains(etkin)) {
        e.preventDefault();
        son.focus();
      }
    } else if (etkin === son) {
      e.preventDefault();
      ilk.focus();
    } else if (!kutu.contains(etkin)) {
      e.preventDefault();
      ilk.focus();
    }
  }

  /* Sekmeler arasında ok tuşuyla gezinme (WAI-ARIA tablist davranışı). */
  function sekmeOk(e, sekme) {
    var sekmeler = sekmeleri(panel);
    if (sekmeler.length < 2) return;

    var i = sekmeler.indexOf(sekme);
    if (i < 0) return;

    var y = i;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      y = (i + 1) % sekmeler.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      y = (i - 1 + sekmeler.length) % sekmeler.length;
    } else if (e.key === 'Home') {
      y = 0;
    } else if (e.key === 'End') {
      y = sekmeler.length - 1;
    } else {
      return;
    }

    e.preventDefault();
    var hedef = sekmeler[y];
    sekmeSec(hedef.getAttribute('data-maiyko-br-sekme'));
    hedef.focus();
  }

  function baglaBirKez() {
    if (baglandi) return;
    baglandi = true;

    document.addEventListener('click', function (e) {
      var hedef = e.target;
      if (!hedef || hedef.nodeType !== 1) {
        hedef = hedef && hedef.parentNode ? hedef.parentNode : null;
      }
      if (!hedef) return;

      var acDugme = closest(hedef, AC_SEC);
      if (acDugme) {
        e.preventDefault();
        ac(acDugme);
        return;
      }

      if (!acik) return;

      if (closest(hedef, KAPAT_SEC)) {
        e.preventDefault();
        kapat(false);
        return;
      }

      if (closest(hedef, KARARTMA_SEC)) {
        kapat(false);
        return;
      }

      var sekme = closest(hedef, SEKME_SEC);
      if (sekme && panel && panel.contains(sekme)) {
        e.preventDefault();
        sekmeSec(sekme.getAttribute('data-maiyko-br-sekme'));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!acik || !panel) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        kapat(false);
        return;
      }

      if (e.key === 'Tab') {
        odakTuzagi(e);
        return;
      }

      var sekme = closest(e.target, SEKME_SEC);
      if (sekme && panel.contains(sekme)) sekmeOk(e, sekme);
    });
  }

  /* ------------------------------------------------------------------ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      kurulum(null);
    });
  } else {
    kurulum(null);
  }

  /* Tema editörü: section yeniden yüklendiğinde taze paneli devral.
     DİKKAT: TOG içeriği yüklenince aynı olay maiyko-tog.js'in kurulumunu
     tetiklemek için TOG kabından da yayılır (togIcerikYukle) — o olay
     BURADA yok sayılır, yoksa kurulum() açık paneli kapatırdı. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && closest(e.target, '[data-maiyko-br-tog]')) return;
    kurulum(e && e.target ? e.target : null);
  });

  /* Section kaldırılırsa: PORTAL edilen panel body'nin çocuğudur, section
     ile birlikte gitmez. Sayfada başka açma düğmesi kalmadıysa panel de
     artakalmasın (kilit ve karartma da temizlenir). */
  document.addEventListener('shopify:section:unload', function () {
    if (!document.querySelector(AC_SEC)) {
      if (acik) kapat(true);
      if (panel && panel.parentNode) {
        try {
          panel.parentNode.removeChild(panel);
        } catch (e) {
          /* yoksay */
        }
      }
      panel = null;
    }
  });
})();
